export default class CrallRecommendation {
    constructor(r) {
        this.item = {};
        if(r != false) {
            this.item = r;
        }

        this.defaults();
    }

    isset(key) {
        if(typeof this.item[key] === 'undefined') {
            return false;
        }

        return true;
    }

    output() {
        return this.item;
    }

    defaults() {
        if(!this.isset('recommendation_id')) {
            this.item.value = 0;
        }

        if(!this.isset('html')) {
            this.item.html = '';
        }

        if(!this.isset('id')) {
            this.item.id = false;
        }
    }
}



// WEBPACK FOOTER //
// ./helpers/crallrecommendation.js